import { pipe } from 'ramda';
import { TCaEventCreator, TCaEventDataSelector, TEventDataParser } from '../types';
import { TProducts, TVacancies } from './types';
import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../getSiteType';
import { sendCaEvent } from '../sendCaEvent';

type TExtra = TProducts;
type TEventData = TVacancies;

type TRawData = {
  deviceType: TDeviceType;
  vacancyId: number;
};

const parseEventData: TEventDataParser<TRawData, TEventData> = props => ({
  siteType: getSiteType(props.deviceType),
  vacancies: [{ id: props.vacancyId }],
});

const selectEventData: TCaEventDataSelector<TRawData> = state => ({
  deviceType: state.page.deviceType,
  vacancyId: state.vacancies.vacancy?.id as number,
});

const createOpenApplyFormEvent: TCaEventCreator<TExtra, TEventData> = props => ({
  name: 'newpage',
  category: 'page',
  action: 'newpage',
  label: 'open',
  page: {
    pageType: 'VacResponse',
    siteType: props.siteType,
  },
  products: props.vacancies,
});

const createOpenRecommendFormEvent: TCaEventCreator<TExtra, TEventData> = props => ({
  name: 'newpage',
  category: 'page',
  action: 'newpage',
  label: 'open',
  page: {
    pageType: 'VaсRecommend',
    siteType: props.siteType,
  },
  products: props.vacancies,
});

const getOpenFormEventData = pipe(selectEventData, parseEventData);

export const sendOpenApplyFormEvent = pipe(getOpenFormEventData, createOpenApplyFormEvent, sendCaEvent);
export const sendOpenRecommendFormEvent = pipe(getOpenFormEventData, createOpenRecommendFormEvent, sendCaEvent);
